import { styled } from "~/common/mui";
import { OverlayContent, OverlayHeader } from "~/common/components/Overlay/Overlay";

export const ComparisonOverlayHeader = styled(OverlayHeader)({
  marginBottom: 0,
});

export const ComparisonOverlayContent = styled(OverlayContent)({
  paddingTop: 0,
});
